module.exports = (sprintf) => (singular, plural, count) => {
  if (count > 1) return sprintf(plural, { count });

  return sprintf(singular, { count });
};
